<template>
  <div class="outer-box max-w-xl">
    <h4>Syncing Brand and Campaign</h4>

    <b-alert show variant="info" class="text-left m-3">
      Syncs the information from Twilio console to GHL database, Use it if you see any discrepancies
      in the data in Twilio and GHL
    </b-alert>

    <div class="inner-box">
      <div>Location ID</div>
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />
      <br />
      <div>Company ID</div>
      <input class="hl_input--wrap" type="text" placeholder="Company ID" v-model="agencyId" />
      <br />
      <button
        :disabled="disabled || processing"
        class="btn btn-danger mt-4"
        @click="syncBrandAndCampaign"
      >
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Sync Brand and Campaign</span>
      </button>
      <pre v-if="response" class="bg-f2f7fa p-16 mt-16">{{ response }}</pre>
    </div>
  </div>
</template>

<script>
import { ISVService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
      agencyId: "",
    };
  },
  computed: {
    disabled() {
      if (!this.locationId) return true;
      if (!this.agencyId) return true;
      else return false;
    },
  },
  methods: {
    async syncBrandAndCampaign() {
      try {
        this.processing = true;
        this.response = (
          await ISVService.syncBrandAndCampaign(this.agencyId, this.locationId)
        ).data;
      } catch (err) {
        this.response = err.response.data;
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>
.inner-box {
  text-align: left;
  width: 500px;
}
</style>
